export default __webpack_public_path__ + "static/media/ic_persons.aabfff9a.svg";